import React from 'react';
import { observer } from "mobx-react";
import { TitanJackpotWidgetConfiguration } from "../../services/configurations/config-data-sections/titan-jackpot-widget.configuration";
import { JackpotWidgetAspectRatioBox } from '../jackpot-widget/boxes/aspect-ratio/jackpot-widget-aspect-ratio.box';
import { JackpotWidgetBgBox } from '../jackpot-widget/boxes/bg/jackpot-widget-bg.box';
import { JackpotWidgetBox } from '../jackpot-widget/boxes/jackpot-widget.box';
import { JACKPOT_WIDGET_LAYOUT } from '../jackpot-widget/jackpot-widget.component';
import { JackpotType } from '../../../common/const/jackpot_map_ids';
import { TitanJackpotAnimationComponent } from './titan-jackpot-animation.component';
import { TitanJackpotAmountComponent } from './titan-jackpot-amount.component';
import { JackpotWidgetClockLabelSkeletonBox } from '../jackpot-widget/skeleton/boxes/footer/jackpot-widget-clock-label-skeleton.box';
import { JackpotWidgetCollectingLabelSkeletonBox } from '../jackpot-widget/skeleton/boxes/footer/jackpot-widget-collecting-label-skeleton.box';
import { JackpotWidgetFooterSkeletonBox } from '../jackpot-widget/skeleton/boxes/footer/jackpot-widget-footer-container-skeleton.box';
import { JackpotWidgetAmountSkeletonBox } from '../jackpot-widget/skeleton/boxes/jackpot-widget-amount-skeleton.box';
import { Check } from '@sparkware/app-utils';
import { useServices } from '../../react-hooks/use-services.hook';


interface ITitanJackpotWidgetProps {
    WrapperBox?: React.ComponentType;
    widgetConfig?: TitanJackpotWidgetConfiguration;
    onClick?: () => void;
}

export const TitanJackpotWidgetComponent: React.FC<ITitanJackpotWidgetProps> = observer((props: ITitanJackpotWidgetProps) => {
    const services = useServices();

    const WrapperBox = props.WrapperBox || React.Fragment;

    const isJackpotHandlerReady = (): boolean => {
        if (!props.widgetConfig?.jackpotIds?.length) {
            return false;
        }

        return props.widgetConfig.jackpotIds.every(jkpId => {
            const jackpotHandler = services.jackpots.currentJackpotsById[String(jkpId)];
            return !Check.isNullOrUndefined(jackpotHandler?.jackpotData);
        })
    }

    const renderTitanJackpotContent = (): React.ReactNode => {
        return isJackpotHandlerReady() ?
            <>
                <TitanJackpotAnimationComponent widgetConfig={props.widgetConfig} />
                <TitanJackpotAmountComponent />
            </> :
            <>
                <JackpotWidgetAmountSkeletonBox />
                <JackpotWidgetFooterSkeletonBox>
                    <JackpotWidgetCollectingLabelSkeletonBox />
                    <JackpotWidgetClockLabelSkeletonBox />
                </JackpotWidgetFooterSkeletonBox>
            </>;

    }

    if (!props.widgetConfig?.display) {
        return null;
    }

    return (
        <WrapperBox>
            <JackpotWidgetAspectRatioBox layout={JACKPOT_WIDGET_LAYOUT.PORTRAIT}>
                <JackpotWidgetBox onClick={() => props.onClick()} isClickable={!!props.onClick} className="cy-jackpot-widget">
                    <JackpotWidgetBgBox shouldRenderSkeleton={!isJackpotHandlerReady()} jackpotType={JackpotType.Titan} layout={JACKPOT_WIDGET_LAYOUT.PORTRAIT}>
                        {renderTitanJackpotContent()}
                    </JackpotWidgetBgBox>
                </JackpotWidgetBox>
            </JackpotWidgetAspectRatioBox>
        </WrapperBox>
    );
});
